import React from 'react';
import { Link } from 'react-router-dom';

import Inputs from '../../../Components/Inputs/Inputs';
// import {useTranslation} from 'react-i18next';
// import GoogleLogin from 'react-google-login';
import { isSet } from '../../../Utils/CommonFunctions';

const LoginForm = props => {
    const KeyCodes = {
        // comma: 188,
        enter: 13,
    };
    const delimiters = [KeyCodes.comma, KeyCodes.enter];
	const fieldDetail = JSON.parse(props.formData);
	// console.log(props.validationError);
    // const {t} = useTranslation();

    const handleKeyDown = (event) => {   
        // console.log("test");     
        if (delimiters.indexOf(event.keyCode) !== -1 ) {
            props.clicked();
        }
    }

	return (
		<div className="form-login animated fadeIn ">

            <div className="form-group row"> 
                {/* <label htmlFor="" className=" secondary_color col-4 mt-sm-2 text-right">{t('Email')}</label> */}
                <div className={`col-6 pl-0 pr-0 ${isSet(isSet(fieldDetail.email,{email:{error:''}}).error,null)!==null?'error':''}`} data-validate={fieldDetail.email.error}>

                    <Inputs keyDownHandler={handleKeyDown} fieldName="email" formData={JSON.stringify(fieldDetail.email)} changed={props.changed} />
                    <span className="label-input100"> Email </span>
                    {/* { (fieldDetail.email.error === '') ? 
                        null
                        : 
                         <span className="error text-danger">{fieldDetail.email.error}</span>
                        <span className="error text-danger" data-validate={fieldDetail.email.error}>{fieldDetail.email.error}</span>
                    } */}
                </div>
                <div className={`col-6 pl-0 ${isSet(isSet(fieldDetail.password,{password:{error:''}}).error,null)!==null?'error':''}`} data-validate={fieldDetail.password.error}>
                    <div className="view-password-login" onClick={() => props.passwordViewHandler("login","password")} style={{top:'30px', right:'25px'}}>
                        <i className={fieldDetail.password.passwordShow ? 'far fa-eye-slash fourth_light_color' : 'far fa-eye fourth_light_color'}></i>
                    </div>
                    <Inputs keyDownHandler={handleKeyDown} fieldName="password" formData={JSON.stringify(fieldDetail.password)} changed={props.changed}/>
                    <span className="label-input100"> Password </span>
                </div>
                <div className='col-12 pl-0'>
                    <button onClick={props.clicked} className="btn col-12 signInbtn">Log In</button>
                </div>
                
                
            </div>

            {/* 
            <div className="form-group row mb-3 position-relative"> 
                <label htmlFor="" className=" secondary_color col-4 mt-sm-2 text-right">Password</label>
                <div className="col-12">
                    <div className="view-password-login" onClick={() => props.passwordViewHandler("login","password")} style={{top:'5px', right:'20px'}}>
                        <i className={fieldDetail.password.passwordShow ? 'far fa-eye-slash fourth_light_color' : 'far fa-eye fourth_light_color'}></i>
                    </div>
                    <Inputs keyDownHandler={handleKeyDown} fieldName="password" formData={JSON.stringify(fieldDetail.password)} changed={props.changed}/>
                </div>
            </div>
            */}

            {/*
            <div className="form-group mb-1">
                <label htmlFor="" className=" secondary_color">{t('Email')}</label>
                <Inputs fieldName="email" formData={JSON.stringify(fieldDetail.email)} changed={props.changed}/>
            </div>
            <div className="form-group position-relative">
                <label htmlFor="" className="secondary_color">Password</label>
                <div className="view-password-login" onClick={() => props.passwordViewHandler("login","password")}>
                    <i className={fieldDetail.password.passwordShow ? 'far fa-eye-slash fourth_light_color' : 'far fa-eye fourth_light_color'}></i>
                </div>
                <Inputs fieldName="password" formData={JSON.stringify(fieldDetail.password)} changed={props.changed}/>

            </div>
            */}
            <div className="form-group form-action d-flex mb-3" style={{alignItems:'center', justifyContent:'space-between'}}>
                 
                {/* <div className="custom-control custom-checkbox">
                    <input type="checkbox" className="custom-control-input" id="rememberme" />
                    <label className="custom-control-label m-0 fourth_dark_color" htmlFor="rememberme">Keep me logged in</label>
                </div> */}
                 
                 
                
                <Link to="forgot-password" className="link float-right">Forget Password ?</Link>
                
            </div>
            <div className="form-group mb-0" style={{paddingLeft:'0rem', textAlign:'center'}}> 
                {/* <button onClick={props.clicked} className="btn col-12 signInbtn ">Log In</button> */}


                {/* <label className="mt-3 col-12 text-center" style={{fontWeight:'bold'}}> — or — </label>  */}

                {/*<a href="#" className="btn col-12 primary_bg mt-3 mt-sm-0 radius_50"><span className="google-icon"><i className="fab fa-google fa-lg primary_color"></i></span> Sign in with Google</a>*/}

                {/* <GoogleLogin
                    clientId="763636507456-sr3r58qu0mdebbv5n178gbhokm6puan3.apps.googleusercontent.com"
                    render={renderProps => (
                      <button onClick={renderProps.onClick} className="btn col-12 google_bg">
                        <span className="google-icon pr-3">
                        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 256 262" id="google">
                            <path fill="#4285F4" d="M255.878 133.451c0-10.734-.871-18.567-2.756-26.69H130.55v48.448h71.947c-1.45 12.04-9.283 30.172-26.69 42.356l-.244 1.622 38.755 30.023 2.685.268c24.659-22.774 38.875-56.282 38.875-96.027"></path>
                            <path fill="#34A853" d="M130.55 261.1c35.248 0 64.839-11.605 86.453-31.622l-41.196-31.913c-11.024 7.688-25.82 13.055-45.257 13.055-34.523 0-63.824-22.773-74.269-54.25l-1.531.13-40.298 31.187-.527 1.465C35.393 231.798 79.49 261.1 130.55 261.1"></path>
                            <path fill="#FBBC05" d="M56.281 156.37c-2.756-8.123-4.351-16.827-4.351-25.82 0-8.994 1.595-17.697 4.206-25.82l-.073-1.73L15.26 71.312l-1.335.635C5.077 89.644 0 109.517 0 130.55s5.077 40.905 13.925 58.602l42.356-32.782"></path>
                            <path fill="#EB4335" d="M130.55 50.479c24.514 0 41.05 10.589 50.479 19.438l36.844-35.974C195.245 12.91 165.798 0 130.55 0 79.49 0 35.393 29.301 13.925 71.947l42.211 32.783c10.59-31.477 39.891-54.251 74.414-54.251"></path>
                        </svg>
                        </span> 
                        Login with Google
                        </button>
                    )}
                    buttonText="Login"
                    onSuccess={props.responseGoogle}
                    onFailure={props.responseGoogle}
                /> */}
            </div>

            
                {
                    props.validationError  ? 
                        Array.isArray(props.validationError) ? 
                            <div className="form-group mt-3 mb-0 animated slideInUp text-center" role="alert"><span className="text-danger"><i className="fas fa-exclamation-triangle fa-lg"></i> {props.validationError.join(", ")}</span></div>
                        : <div className="form-group mt-3 mb-0 animated slideInUp text-center" role="alert"><span className="text-danger"><i className="fas fa-exclamation-triangle fa-lg"></i> {props.validationError}</span></div> 
                    : null
                }
            
        </div> 
	);
}

export default LoginForm;